export default "__VITE_ASSET__4fedbca3__"